import { LoadState } from "../../constants/enums";

export interface IStatusState {
  masterStatusList: {
    list: IMasterStatus[];
    loading: LoadState;
    totalRecords: number;
    error: string | null;
  };

  masterStatus: {
    data: IMasterStatus;
    loading: LoadState;
    error: string | null;
  };
}

export interface IMasterStatus {
  master_status_uuid: string | null;
  name: string;
  description: string;
  status: "ACTIVE" | "INACTIVE";
  billing_company_uuid: string;
  created_by_uuid: string;
  created_by_name: string;
  modified_by_uuid: string;
  modified_by_name: string;
}

export const initialMasterStatus: IMasterStatus = {
  master_status_uuid: "",
  name: "",
  description: "",
  status: "ACTIVE",
  billing_company_uuid: "",
  created_by_uuid: "",
  created_by_name: "",
  modified_by_uuid: "",
  modified_by_name: "",
};

export const initialStatusState: IStatusState = {
  masterStatusList: {
    list: [],
    loading: LoadState.NotLoaded,
    totalRecords: 0,
    error: null,
  },
  masterStatus: {
    data: initialMasterStatus,
    loading: LoadState.NotLoaded,
    error: null,
  },
};
